<template lang="pug">
v-card.pa-3(height='calc(100vh - 112px)' )
  .d-flex.ai-center.jc-center.mt-4
    v-card-text.pa-0(v-for="(a, index) in lista" :key="index")
      div(v-for="(r, index2) in Object.keys(a)")
        v-text-field(:label="r" v-model="a[r]" dense  )
  .d-flex
    v-spacer
    v-btn.py-2(:block="isMovil" color="success",  :small="!isMovil"  @click="fetchGuardar()") Guardar cambios

</template>
<script>
import { apiGet, apiPost, notify } from '../util/general'
export default {
  data () {
    return {
      lista: []
    }
  },
  created () {
    var vm = this
    vm.fetch()
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    fetch () {
      var vm  = this
      var url = '/parametro/obtener'
      var obj = {}
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo parametros' })
      apiGet(vm, url, obj, function (data) {
        vm.lista = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    fetchGuardar () {
      var vm  = this
      var url = '/parametro/guardar'
      var obj = {
        columns : vm.lista[0]
      }
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Actualizando parametros' })
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los parametros fuerón cambiados')
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// View_parametros.vue?1e136f72